import { Box, InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { Send } from "@material-ui/icons";
import clsx from "clsx";
import { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import UploadFile from "../../../components/UploadFile";
import { GenericFunction } from "../../../types/generic.types";
import { IAttachment, IChatParams } from "../type";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "90%",

    "& div[class*=MuiOutlinedInput-multiline]": {
      height: "100%",
      padding: theme.spacing(2),
      borderRadius: "50px",
    },
    "& div[class*=MuiOutlinedInput-inputAdornedEnd]": {
      height: 30,
    },
  },
  icon: {
    cursor: "pointer",
    marginLeft: 4,
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

const ChatAction: FC<SendMessageProps> = ({ onSend, placeholder, sendAttachment }) => {
  const classes = useStyles({});
  const [value, setValue] = useState<string | null>(null);
  const { roomId } = useParams<IChatParams>();
  const inputRef = useRef<any>();

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setValue(e.target.value);
  };

  const isSendButtonDisabled = () => !value || (value && value.trim().length === 0);

  const resetInput = () => {
    setValue("".trim());
    inputRef.current.focus();
  };

  const handleSendMessage = () => {
    onSend(value, null);
    resetInput();
  };

  const handleCommentOnEnter = (e: any) => {
    if (e.which === 13 && !e.shiftKey) {
      onSend(value);
      resetInput();
    }
  };

  const handleUpload = (img: IAttachment | undefined) => {
    if (img) onSend(null, img);
  };

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, [roomId]);

  return (
    <TextField
      className={classes.root}
      fullWidth
      multiline
      rowsMax={3}
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={handleChangeValue}
      onKeyPress={handleCommentOnEnter}
      inputRef={inputRef}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Box display="flex" alignItems="center" justifyContent="space-around">
              {sendAttachment && <UploadFile onUpload={handleUpload} />}
              <Send
                color="primary"
                onClick={handleSendMessage}
                className={clsx([classes.icon], {
                  [classes.disabled]: isSendButtonDisabled(),
                })}
              />
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
};

interface SendMessageProps {
  onSend: GenericFunction;
  placeholder: string;
  sendAttachment?: boolean;
}

export default ChatAction;
